import AddressesIcon from "@svg/AddressesIcon";
import { useTranslations } from "next-intl";

interface EmptySuggestionProps {

}

const EmptySuggestion: React.FC<EmptySuggestionProps> = () => {
  const t = useTranslations();

  return (
    <div className="w-full flex flex-col items-center">
      <AddressesIcon stroke="#999" className="w-10 h-10" />
      <p className="pt-3 text-textLight font-normal text-sm leading-6">{t("client_area_nodatamessage")}</p>
    </div>
  );
}

export default EmptySuggestion;